import type { SVGProps } from 'react';
const DawnFlagMD = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MD_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MD_svg__a)">
      <path fill="#EB1C43" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#115BCB" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#FFD953"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#AF7F59"
        fillRule="evenodd"
        d="M10.476 6.4H9.43v3.2L11 10.667 12.572 9.6V6.4h-1.048L11 4.8zm1.048 1.067h-1.048v1.6h1.048z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMD;
